<template>
  <h1>Oops!</h1>
  <p>L'articolo non è stato trovato oppure è stato rimosso.<br />
    <a href="/search">Torna alla ricerca</a>
  </p>
  <!-- <router-link :to="{ name: 'Scheda', params: { category: '', codListino: '' }  }">Ritorna alla home page</router-link> -->
</template>

<script>
export default {
  props: {
    resource: {
      type: String,
      required: true,
      default: 'page'
    }
  }
}
</script>